var React = require('react');

function PlusNoCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 6V18","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M6 12H18","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]);
}

PlusNoCircle.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 24 24","fill":"none"};

module.exports = PlusNoCircle;

PlusNoCircle.default = PlusNoCircle;
